import { render, staticRenderFns } from "./orderLogistics.vue?vue&type=template&id=2ed07760&scoped=true"
import script from "./orderLogistics.vue?vue&type=script&lang=js"
export * from "./orderLogistics.vue?vue&type=script&lang=js"
import style0 from "./orderLogistics.vue?vue&type=style&index=0&id=2ed07760&scoped=true&lang=scss"
import style1 from "./orderLogistics.vue?vue&type=style&index=1&id=2ed07760&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed07760",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed07760')) {
      api.createRecord('2ed07760', component.options)
    } else {
      api.reload('2ed07760', component.options)
    }
    module.hot.accept("./orderLogistics.vue?vue&type=template&id=2ed07760&scoped=true", function () {
      api.rerender('2ed07760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderLogistics.vue"
export default component.exports